import { createContext, useCallback } from 'react';
import { jsx } from 'react/jsx-runtime';
const CB_PAYMENTS_COUNTRIES = ['AD',
// Andorra
'GI',
// Gibraltar
'GG',
// Guernsey
'IM',
// Isle of Man
'JE',
// Jersey
'MC',
// Monaco
'SM',
// San Marino
'CH',
// Switzerland
'GB' // United Kingdom
];
const EUROPEAN_UNION_LIST = ['BE',
// Belgium
'BG',
// Bulgaria
'CZ',
// Czech Republic
'DK',
// Denmark
'DE',
// Germany
'EE',
// Estonia
'IE',
// Ireland
'GR',
// Greece
'ES',
// Spain
'FR',
// France
'HR',
// Croatia
'IT',
// Italy
'CY',
// Cyprus
'LV',
// Latvia
'LT',
// Lithuania
'LU',
// Luxembourg
'HU',
// Hungary
'MT',
// Malta
'NL',
// Netherlands
'AT',
// Austria
'PL',
// Poland
'PT',
// Portugal
'RO',
// Romania
'SI',
// Slovenia
'SK',
// Slovakia
'FI',
// Finland
'SE',
// Sweden
'GB' // United Kingdom
];

// European Free Trade Association (EFTA)
const EFTA_LIST = ['IS',
// Iceland
'LI',
// Liechtenstein
'NO',
// Norway
'CH' // Switzerland
];
const OFFICIAL_EU_COUNTRIES = [...EUROPEAN_UNION_LIST, ...EFTA_LIST];
const GlobalFooterContext = /*#__PURE__*/createContext({
  userLocaleInfo: undefined,
  isUserFromCountry: () => false,
  isUserFromCBPaymentsCountries: () => false,
  isUserFromEU: () => false,
  IsUserFromAdTrackingOptOutCountries: () => false
});
function GlobalFooterProvider({
  children,
  userLocaleInfo
}) {
  const _userLocaleInfo$count = userLocaleInfo.countryFromIp,
    countryFromIp = _userLocaleInfo$count === void 0 ? '' : _userLocaleInfo$count,
    _userLocaleInfo$count2 = userLocaleInfo.countryFromUrl,
    countryFromUrl = _userLocaleInfo$count2 === void 0 ? '' : _userLocaleInfo$count2;
  const isUserFromCountry = useCallback((country, onlyCheckIp = false) => {
    if (onlyCheckIp) {
      return countryFromIp?.toUpperCase() === country;
    }
    return countryFromIp?.toUpperCase() === country || countryFromUrl?.toUpperCase() === country;
  }, [countryFromIp, countryFromUrl]);
  const isUserFromCBPaymentsCountries = useCallback((onlyCheckIp = false) => {
    if (onlyCheckIp) {
      return CB_PAYMENTS_COUNTRIES.includes(countryFromIp?.toUpperCase());
    }
    return CB_PAYMENTS_COUNTRIES.includes(countryFromIp?.toUpperCase()) || CB_PAYMENTS_COUNTRIES.includes(countryFromUrl?.toUpperCase());
  }, [countryFromIp, countryFromUrl]);
  const isUserFromEU = useCallback((onlyCheckIp = false) => {
    if (onlyCheckIp) {
      return OFFICIAL_EU_COUNTRIES.includes(countryFromIp?.toUpperCase());
    }
    return OFFICIAL_EU_COUNTRIES.includes(countryFromIp?.toUpperCase()) || OFFICIAL_EU_COUNTRIES.includes(countryFromUrl?.toUpperCase());
  }, [countryFromIp, countryFromUrl]);
  const IsUserFromAdTrackingOptOutCountries = useCallback((onlyCheckIp = false) => {
    if (onlyCheckIp) {
      return isUserFromCBPaymentsCountries(true) || isUserFromEU(true) || isUserFromCountry('US', true) || isUserFromCountry('DE', true) || isUserFromCountry('ES', true);
    }
    return isUserFromCBPaymentsCountries() || isUserFromEU() || isUserFromCountry('US') || isUserFromCountry('DE') || isUserFromCountry('ES');
  }, [isUserFromCBPaymentsCountries, isUserFromCountry, isUserFromEU]);
  return /*#__PURE__*/jsx(GlobalFooterContext.Provider, {
    value: {
      userLocaleInfo,
      isUserFromCountry,
      isUserFromCBPaymentsCountries,
      isUserFromEU,
      IsUserFromAdTrackingOptOutCountries
    },
    children: children
  });
}
export { GlobalFooterContext, GlobalFooterProvider };
//# sourceMappingURL=GlobalFooterContext.js.map
